import { useToasterStore } from '@shared/stores/toaster'
import {
  getAccessToken,
  getHasAdvisingReportAuthToken,
} from 'src/services/AppContext'
import { LOCAL_STORAGE_KEYS } from 'src/tpbp-core/models/common.const'
import Vue from 'vue'
import Router, { type RouteConfig } from 'vue-router'
import { ROUTE_NAMES } from './routeNames.const'

Vue.use(Router)

const baseUrl =
  typeof process.env.BASE_URL === 'string' ? process.env.BASE_URL : ''

const router = new Router({
  mode: 'hash',
  base: baseUrl,
  routes: [
    {
      path: '/',
      name: 'app',
      redirect: '/welcome',
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
})

router.beforeEach((routeTo, _, next) => {
  useToasterStore().clearToaster()

  if (routeTo.name === ROUTE_NAMES.landing) {
    next()

    return
  }

  if (getAccessToken() && getHasAdvisingReportAuthToken()) {
    if (routeTo.name === ROUTE_NAMES.advisingReportPdf) {
      next()
    } else {
      redirectToLogin(routeTo.path)
    }
    return
  }

  if (
    getAccessToken() &&
    localStorage.getItem(LOCAL_STORAGE_KEYS.REFRESH_TOKEN)
  ) {
    next()
  } else {
    redirectToLogin(routeTo.path)
  }

  function redirectToLogin(_, redirectFrom = '') {
    const loginRoute: {
      name: string
      query?: Record<string, string>
    } = { name: ROUTE_NAMES.landing }
    if (redirectFrom) {
      loginRoute.query = { redirectFrom }
    }
    next(loginRoute)
  }
})

export function addRoutes(router: Router, routes: RouteConfig[]) {
  for (const route of routes) {
    router.addRoute(route)
  }
}

export function exitCircuit() {
  router.push({ name: ROUTE_NAMES.synthesis })
}

export { router }
